import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {formatCurrencyKMBT} from "../../../utilities/formatters";
import {QUARTILE_COLORS} from "../../../utilities/constants";
import {TEXT} from "../../../utilities/strings";

/**
 * Component for displaying chart legend and values for state and county maps
 *
 * If a quantile is not represented in the data (ie. no rows have quantile 2)
 * then that legend item will be hidden if possible.
 *
 * @property title - string to be displayed as legend title
 * @property data - array of location models to calculate the legend values
 * @property quantileField - field in data objects that holds the quantile (1-4)
 * @property valueField - field in data objects that holds the numeric value to create ranges
 *
 * @example
 * return (
 *   <LegendView
 *     data={[...]}
 *     quantileField={mapProperty}
 *     valueField={legendProperty}
 *   />
 * )
 */
export default class LegendView extends PureComponent {

  static propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    quantileField: PropTypes.string,
    valueField: PropTypes.string
  };

  getValueRange = (quantile) => {
    const min = _.chain(this.props.data)
      .filter([this.props.quantileField, quantile])
      .minBy(this.props.valueField)
      .get(this.props.valueField)
      .castArray()
      .first()
      .value()

    const max = _.chain(this.props.data)
      .filter([this.props.quantileField, quantile])
      .maxBy(this.props.valueField)
      .get(this.props.valueField)
      .castArray()
      .first()
      .value()

    return [min, max]
  }

  renderQuantileRow = (quantile) => {
    const [min, max] = this.getValueRange(quantile);

    return !isNaN(max) && (
      <div key={quantile}>
        {this.renderSvgRect(quantile)}
        {formatCurrencyKMBT(min)} to {formatCurrencyKMBT(max)}
      </div>
    )
  }

  renderSvgRect = (quantile) => (
    <svg className="mb-1 mt-1 mr-2" width="16" height="18">
      <rect x="1" y="1" rx="10" ry="10" width="14" height="14" stroke={'#333'} strokeWidth={1}
            fill={QUARTILE_COLORS[quantile] || 'url(#crosshatch)'}
      />
    </svg>
  )

  render() {
    return (
      <div className="LegendView font-sm screen-reader-hidden">

        <div className="pb-2"><strong>{this.props.title}</strong></div>

        {[1, 2, 3, 4].map(q => this.renderQuantileRow(q))}

        <div className="mb-1 mt-1">
          {this.renderSvgRect(null)}
          {TEXT.suppressed_data}
        </div>

      </div>
    )
  }
}
